export default "__VITE_ASSET__DwpU2y0E__"